import * as React from "react";
import { forwardRef } from "react";
const SvgParts = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { opacity: 0.6, d: "M12 10L20 6V17L12 21L12 10Z", fill: "currentColor" }), /* @__PURE__ */ React.createElement("path", { d: "M4 17L12 21V10L4 6V17Z", fill: "currentColor" }), /* @__PURE__ */ React.createElement("path", { opacity: 0.4, d: "M4 6L12 10L20 6L12 2L4 6Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgParts);
export default ForwardRef;
